import { motion } from "framer-motion";
import { ArrowUpRight, ShieldCheck } from "lucide-react";
import homecta from "../../assets/images/homecta.jpg";
import { Link } from "react-router-dom";
export default function HomeContact() {
  return (
    <section className="relative w-full lg:py-24 md:py-16 py-10 bg-[#f7f7f5] text-slate-900 overflow-hidden">
      <div
        className="pointer-events-none absolute top-0 w-full h-full opacity-60"
        style={{
          background:
            "linear-gradient(to right, #62d4f7 0%, #5dc9f0 50%, #3579be 80%)",
        }}
      />
      <div className="mx-auto 3xl:w-4/5 lg:w-11/12 px-6 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7 flex flex-col justify-between">
            <div>
              <motion.div
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="inline-flex items-center gap-2 px-0.5 py-1.5  backdrop-blur-md shadow-xs mb-6"
              >
                <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-700">
                  Next Chapter
                </span>
              </motion.div>

              <motion.h2
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.08 }}
                className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-slate-950 leading-[1.08]"
              >
                Unleash the Power of{" "}
                <span className="font-serif italic font-normal text-slate-600">
                  Innovation
                </span>{" "}
                with Truviq
              </motion.h2>

              <motion.p
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.15 }}
                className="mt-6 text-base sm:text-lg text-slate-600 font-normal leading-relaxed max-w-xl"
              >
                Ready to elevate your business? Partner with us to streamline
                processes, enhance operational efficiency, and achieve your
                goals with confidence.
              </motion.p>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.22 }}
              className="mt-10 pt-8 border-t border-slate-300/80 flex flex-col sm:flex-row sm:items-center gap-6"
            >
              <Link
                to="/contact"
                className="group relative inline-flex items-center justify-between gap-3 px-5 py-3 border border-black/15 bg-slate-950 text-white font-mono text-xs font-semibold uppercase tracking-widest transition-all duration-300 hover:bg-white hover:text-slate-700 hover:shadow-lg"
                style={{
                  borderRadius: "999px",
                }}
              >
                <span>Let’s Innovate Together</span>
                <div className="h-7 w-7 rounded-full bg-white/10 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5 group-hover:bg-slate-700 group-hover:text-white">
                  <ArrowUpRight size={15} />
                </div>
              </Link>
              <div className="flex items-center gap-3 text-base font-mono text-[#000036]">
                <ShieldCheck size={16} className="text-slate-900 shrink-0" />
                <span>Enterprise SLA • Global Compliance</span>
              </div>
            </motion.div>
          </div>

          <div className="lg:col-span-5 relative">
            <motion.div
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="relative h-[420px] sm:h-[480px] w-full rounded-xl overflow-hidden bg-slate-200  shadow-[0_20px_50px_rgba(0,0,0,0.06)]"
            >
              <img
                src={homecta}
                alt="Corporate Architecture"
                className="h-full w-full object-cover grayscale contrast-125 brightness-105"
              />

              <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#f7f7f5]/80 via-transparent to-transparent hidden lg:block" />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-slate-950/40 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 p-4 rounded-xl bg-[#000036] backdrop-blur-xl  shadow-md flex items-center justify-between">
                <div>
                  <span className="text-xs font-mono uppercase tracking-widest text-white block">
                    Enterprise Deployment
                  </span>
                  <span className="font-display text-sm font-bold text-white">
                    Next-Gen Scaled Delivery
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
